<template>
  <div style="margin: 10px; width: calc(100vw - 85px)">
    <el-dialog
      :visible.sync="isOpenTemporaryLinkForm"
      :title="isNewTemporaryLink?$t('settings.temporary_link_add'):$t('settings.temporary_link_edit')"
      custom-class="temporary-link-dialog"
      width="min(980px, 94vw)"
    >
      <el-form :model="temporaryLinkForm">
        <el-form-item :label="$t('settings.user_name')">
          <el-input v-model="temporaryLinkForm.name" />
        </el-form-item>
        <div class="form-item-block">
          <div class="form-item-row">
            <el-form-item class="form-item-block-left" :label="$t('settings.expiration_date')">
              <el-date-picker
                v-model="temporaryLinkForm.expirationTime"
                type="datetime"
                :placeholder="$t('Seleccionar fecha')"
                style="width: 100%"
                default-time="23:59:59"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="form-item-block-right" :label="$t('Destination Address')">
              <el-input
                id="input"
                v-model="searchAddress"
                type="search"
                style="width: 100%"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="form-item-row">
            <el-form-item class="form-item-block-left" :label="$t('settings.allowed_start_time')">
              <el-time-picker
                v-model="temporaryLinkForm.allowedStartTime"
                format="HH:mm"
                value-format="HH:mm"
                :placeholder="$t('settings.selectStartTime')"
                style="width: 100%"
              ></el-time-picker>
            </el-form-item>
            <el-form-item class="form-item-block-right" :label="$t('settings.allowed_end_time')">
              <el-time-picker
                v-model="temporaryLinkForm.allowedEndTime"
                format="HH:mm"
                value-format="HH:mm"
                :placeholder="$t('settings.selectEndTime')"
                style="width: 100%"
              ></el-time-picker>
            </el-form-item>
          </div>
          <el-form-item class="allowed-week-days-item" :label="$t('settings.allowed_week_days')">
            <el-checkbox-group v-model="temporaryLinkForm.allowedWeekDays" class="allowed-week-days">
              <el-checkbox
                v-for="day in weekDays"
                :key="day.value"
                :label="day.value"
              >{{ day.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <el-form-item class="temporary-link-transfer" style="padding-top: 20px">
          <el-transfer
            v-model="selectedLinkDevices"
            :filter-method="filteredDevices"
            filterable
            :filter-placeholder="$t('report.selector_search')"
            :titles="[$t('settings.vehicles'), $t('report.select_vehicles')]"
            :props="{
              key: 'id',
              label: 'name'
            }"
            :data="devices"
            :render-content="renderFunc"
          >
          </el-transfer>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="info"
          class="formButton"
          size="small"
          @click="handleCancelForm"
        >{{ $t('settings.form_cancel') }}</el-button>
        <el-button
          :loading="loading"
          type="success"
          class="formButton"
          size="small"
          @click="handleSubmitForm"
        >{{ $t('settings.form_save') }}</el-button>
      </span>
    </el-dialog>
    <el-table
      height="calc(100vh - 100px)"
      :row-style="tableRowStyle"
      :header-cell-style="tableHeaderStyle"
      :data="filteredUsers"
      :default-sort="{ prop: 'expirationTime', order: 'ascending' }"
    >
      <el-table-column
        :label="$t('settings.user_name')"
        width="300px"
        prop="name"
        sortable
      >
      </el-table-column>
      <el-table-column
        width="175px"
        :label="$t('settings.expiration_date')"
        prop="expirationTime"
        sortable
      >
        <template slot-scope="scope">
          <span>{{ scope.row.expirationTime | moment("YYYY-MM-DD HH:mm:ss") }}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="170px"
        :label="$t('settings.allowed_time')"
      >
        <template slot-scope="scope">
          <span>{{ allowedTime(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="230px"
        :label="$t('settings.allowed_week_days')"
      >
        <template slot-scope="scope">
          <span>{{ allowedWeekDays(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="220px"
        :label="$t('settings.vehicles')"
      >
        <template slot-scope="scope">
          <span>{{ selectedDeviceName(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('settings.user_temporary_link')">
        <template slot-scope="scope">
          <a :href="externalLink(scope.row)" target="_blank" style="padding-right: 10px">{{ externalLink(scope.row) }}</a>
          <el-tooltip :content="$t('Copy Link')" placement="top">
            <el-button type="small" @click="copy(externalLink(scope.row))"><i class="fas fa-clone"></i></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="" width="80px">
        <template slot="header">
          <div style="float: right">
            <el-tooltip :content="$t('settings.add')" placement="top">
              <el-button
                class="formButton"
                size="small"
                @click="handleAdd"
              ><i class="fas fa-plus"></i></el-button>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <el-tooltip :content="$t('settings.delete')" placement="top">
            <el-button
              class="formButton"
              size="small"
              type="danger"
              @click="handleDelete(scope.row)"
            ><i class="fas fa-trash-alt"></i></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="total"
      :total="filteredUsers.length"
    >
    </el-pagination>
  </div>
</template>

<script>
import { vm } from '@/main'
import { mapGetters } from 'vuex'
import { traccar } from '@/api/traccar-api'
import Vue from 'vue'
import { Loader } from '@googlemaps/js-api-loader'

export default {
  name: 'TemporaryLinks',
  data() {
    return {
      searchAddress: '',
      isOpenTemporaryLinkForm: false,
      isNewTemporaryLink: true,
      selectedTemporaryLink: null,
      search: '',
      loading: false,
      temporaryLinkDevices: {},
      temporaryLinkForm: {
        poi: null,
        name: '',
        expirationTime: '',
        allowedStartTime: '00:00',
        allowedEndTime: '23:59',
        allowedWeekDays: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
        linkDevices: [],
        linkSelectedDevices: []
      },
      filteredDevices(query, item) {
        return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1
      }
    }
  },
  computed: {
    ...mapGetters(['user', 'users', 'devices', 'geofences']),
    filteredUsers() {
      return this.users.filter(u => u.email.startsWith('temp_')).filter(data => (!this.search ||
        data.name.toLowerCase().includes(this.search.toLowerCase()) ||
        data.email.toLowerCase().includes(this.search.toLowerCase())))
    },
    selectedLinkDevices: {
      get() {
        return this.temporaryLinkForm.linkSelectedDevices
      },
      set(value) {
        this.temporaryLinkForm.linkSelectedDevices = value.slice(-1)
      }
    },
    weekDays() {
      return [
        { value: 'monday', label: this.$t('settings.monday') },
        { value: 'tuesday', label: this.$t('settings.tuesday') },
        { value: 'wednesday', label: this.$t('settings.wednesday') },
        { value: 'thursday', label: this.$t('settings.thursday') },
        { value: 'friday', label: this.$t('settings.friday') },
        { value: 'saturday', label: this.$t('settings.saturday') },
        { value: 'sunday', label: this.$t('settings.sunday') }
      ]
    }
  },
  watch: {
    filteredUsers: {
      immediate: true,
      handler(users) {
        this.loadTemporaryLinkDevices(users)
      }
    },
    isOpenTemporaryLinkForm(value) {
      if (value && !this.autoComplete) {
        new Loader({
          apiKey: process.env.googleKey, libraries: ['places']
        }).load().then(() => {
          // eslint-disable-next-line no-undef
          this.autoComplete = new google.maps.places.Autocomplete(document.getElementById('input'))
          this.autoComplete.addListener('place_changed', this.onPlaceChanged)
        })
      }
    }
  },
  methods: {
    onPlaceChanged() {
      const place = this.autoComplete.getPlace()
      if (place.geometry) {
        this.temporaryLinkForm.poi = `${place.geometry.location.lng()},${place.geometry.location.lat()}`
        this.searchAddress = place.formatted_address
      }
    },
    copy(link) {
      navigator.clipboard.writeText(link)
      this.$notify({
        title: 'Copiado',
        message: 'Copiado para a área de transferência (clipboard).',
        type: 'success'
      })
    },
    randomString() {
      return Math.random().toString(36).substr(2) + Math.random().toString(36).substr(2)
    },
    externalLink(user) {
      return `https://eta.fleetmap.io/?token=${user.token}`
    },
    allowedTime(user) {
      return user.attributes && user.attributes.allowedStartTime && user.attributes.allowedEndTime
        ? `${user.attributes.allowedStartTime} - ${user.attributes.allowedEndTime}`
        : ''
    },
    allowedWeekDays(user) {
      const allowedWeekDays = user.attributes && user.attributes.allowedWeekDays
      return allowedWeekDays && allowedWeekDays.length
        ? this.weekDays.filter(day => allowedWeekDays.includes(day.value)).map(day => day.label).join(', ')
        : ''
    },
    selectedDeviceName(user) {
      const device = this.temporaryLinkDevices[user.id]
      return device ? device.name : ''
    },
    loadTemporaryLinkDevices(users) {
      users.filter(user => !this.temporaryLinkDevices[user.id]).forEach(user => {
        traccar.devicesByUser(user.id)
          .then(response => {
            this.$set(this.temporaryLinkDevices, user.id, response.data[0] || null)
          })
          .catch(error => {
            Vue.$log.error(error)
          })
      })
    },
    tableRowStyle() {
      return 'font-size: 14px'
    },
    tableHeaderStyle() {
      return 'font-size: 14px'
    },
    async handleEdit(row) {

    },
    handleAdd() {
      this.isNewTemporaryLink = true
      this.selectedTemporaryLink = null
      this.temporaryLinkForm.name = ''
      this.temporaryLinkForm.expirationTime = ''
      this.temporaryLinkForm.allowedStartTime = '00:00'
      this.temporaryLinkForm.allowedEndTime = '23:59'
      this.temporaryLinkForm.allowedWeekDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
      this.temporaryLinkForm.linkDevices = []
      this.temporaryLinkForm.linkSelectedDevices = []
      this.temporaryLinkForm.poi = null
      this.searchAddress = ''
      this.isOpenTemporaryLinkForm = !this.isOpenTemporaryLinkForm
    },
    handleDelete(row) {
      this.$confirm(this.$t('settings.temporary_link_delete_info') + row.name, this.$t('settings.temporary_link_delete_title'), {
        confirmButtonText: this.$t('settings.form_confirm'),
        cancelButtonText: this.$t('settings.form_cancel')
      }).then(() => {
        traccar.deleteUser(row.id, this.userDeleted)
      }).catch((error) => {
        this.$log.error(error)
      })
    },
    userDeleted(id) {
      this.$log.debug('temporary link deleted')
      this.$message({
        message: this.$t('settings.temporary_link_deleted'),
        type: 'success',
        duration: 5 * 1000
      })
      const user = vm.$store.state.user.users.find(u => u.id === id)
      this.$store.dispatch('user/removeUser', user)
    },
    handleCancelForm() {
      this.isOpenTemporaryLinkForm = false
    },
    handleSubmitForm() {
      if (!this.temporaryLinkForm.allowedWeekDays.length) {
        this.$alert(this.$t('settings.select_allowed_week_day'))
      } else if (this.temporaryLinkForm.linkSelectedDevices.length) {
        if (new Date(this.temporaryLinkForm.expirationTime).getTime() > Date.now()) {
          this.loading = true
          const token = this.randomString()
          const newUser = {
            name: this.temporaryLinkForm.name,
            email: 'temp_' + token,
            readonly: true,
            administrator: false,
            password: token,
            token: token,
            expirationTime: this.temporaryLinkForm.expirationTime,
            attributes: {
              'ui.disableReport': true,
              'ui.disableEvents': true,
              'ui.disableVehicleFeatures': true,
              linkVersion: this.temporaryLinkForm.poi,
              endAddress: this.searchAddress,
              allowedStartTime: this.temporaryLinkForm.allowedStartTime,
              allowedEndTime: this.temporaryLinkForm.allowedEndTime,
              allowedWeekDays: this.temporaryLinkForm.allowedWeekDays
            }
          }
          traccar.addUser(newUser)
            .then(response => this.userCreated(response.data))
            .catch(reason => {
              this.loading = false
              try {
                if (reason.response.data.startsWith('Duplicate entry')) {
                  this.$message({
                    message: this.$t('settings.user_duplicated_entry'),
                    type: 'warning',
                    duration: 5 * 1000
                  })
                } else if (reason.response.data.startsWith('Manager access required') ||
                  reason.response.data.startsWith('Account is readonly')) {
                  this.$message({
                    message: this.$t('settings.user_create_not_allowed'),
                    type: 'warning',
                    duration: 5 * 1000
                  })
                } else {
                  console.error(reason)
                  this.$alert(reason.message)
                }
              } catch (e) {
                this.$alert(reason.message)
              }
            })
        } else {
          this.$alert(this.$t('A data limite não pode ser anterior à data actual'))
        }
      } else {
        this.$alert(this.$t('Seleccione um veículo'))
      }
    },
    userCreated: async function(newUser) {
      try {
        await this.$store.dispatch('user/addUser', newUser)

        await this.updateUserPermissions(newUser)

        this.$message({
          type: 'success',
          message: this.$t('settings.temporary_link_created')
        })
      } catch (e) {
        Vue.$log.error(e)
      } finally {
        this.isOpenTemporaryLinkForm = false
        this.loading = false
      }
    },
    async updateUserPermissions(user) {
      const devicePermissionsToAdd = this.temporaryLinkForm.linkSelectedDevices.map(d => {
        return {
          userId: user.id,
          deviceId: d
        }
      })
      await traccar.addAllPermissions(devicePermissionsToAdd)
      this.$set(this.temporaryLinkDevices, user.id, this.devices.find(d => d.id === this.temporaryLinkForm.linkSelectedDevices[0]) || null)
    },
    renderFunc(h, option) {
      return <span title={option.name}>{option.name}</span>
    },
    doNothing(scope) {
      /* this method is here because we need the attribute 'slot-scope = "scope"' on the template
       for search box to work, but to be able to commit the variable 'scope' it must be used*/
    }
  }
}
</script>
<style lang="scss">
@import '../../../styles/element-variables.scss';
a {
  color: $--color-primary !important;
}

.dialog__wrapper {
 z-index: 10 !important;
}

.pac-container {
  z-index: 3000 !important;
}

.allowed-week-days {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;

  .el-checkbox {
    flex: 0 0 auto;
    margin-right: 8px;
  }
}

.allowed-week-days-item {
  width: 100%;
}

.temporary-link-dialog {
  display: flex;
  flex-direction: column;
  max-height: 92vh;
  max-width: 980px;

  .el-dialog__body {
    overflow-x: hidden;
    overflow-y: auto;
  }

  .el-dialog__footer {
    flex: 0 0 auto;
  }

  .form-item-block {
    display: block;
  }

  .form-item-row {
    display: flex;
    gap: 36px;
  }

  .form-item-block-left,
  .form-item-block-right {
    display: block;
    flex: 1 1 0;
    min-width: 0;
    padding-right: 0;
    width: auto;
  }

  .el-form-item__label {
    line-height: 22px;
  }

  .el-transfer {
    align-items: stretch;
    justify-content: space-between;
    width: 100%;
  }

  .el-transfer-panel {
    flex: 1 1 0;
    min-width: 0;
  }
}

@media (max-width: 900px) {
  .temporary-link-dialog {
    margin-top: 2vh !important;
    max-height: 96vh;
    width: 94vw !important;

    .form-item-row {
      display: block;
    }

    .el-transfer {
      align-items: center;
      flex-direction: column;
    }

    .el-transfer__buttons {
      justify-content: center;
      padding: 8px 0;
      transform: rotate(90deg);
    }

    .el-transfer-panel {
      flex: 0 0 auto;
      height: 190px;
      width: 100%;

      .el-transfer-panel__list {
        height: 70px;
      }
    }
  }
}

</style>
